/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_OkInputs */

const en_tut_mini_ok = /** @type {(inputs: Tut_Mini_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Mini window shows how many people are present and keeps up with changes without you refreshing it.`)
};

const id_tut_mini_ok = /** @type {(inputs: Tut_Mini_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jendela Mini menampilkan jumlah rekan yang hadir dan mengikuti perubahan tanpa Anda menyegarkannya.`)
};

/**
* | output |
* | --- |
* | "The Mini window shows how many people are present and keeps up with changes without you refreshing it." |
*
* @param {Tut_Mini_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_ok = /** @type {((inputs?: Tut_Mini_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_ok(inputs)
	return en_tut_mini_ok(inputs)
});